<canvas
  baseChart
  [datasets]="_datasets"
  type="line"
  [options]="_chartOptions"
></canvas>
